import React, { useEffect, useState } from 'react'
import { StackNavigationProp } from '@react-navigation/stack'
import { RouteProp } from '@react-navigation/native'
import { View, ScrollView, SafeAreaView } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import tw from 'tailwind-rn'

import { RootStackParamList } from '../../navigators/AppNavigator'
import { HGButton, HGHeading, HGText, HGView } from '../../components/HGUI'
import ActionCreators from '../../store/actions'
import HansGretelLogo from '../auth/HansGretelLogo'

type Props = {
  route: RouteProp<RootStackParamList, 'VerifyEmailAddress'>
  navigation: StackNavigationProp<RootStackParamList>
}

const VerifyEmailAddressScreen = (props: Props) => {
  const dispatch = useDispatch()
  const {
    navigation,
    route: { params },
  } = props
  const { token, email } = params || {}
  const [loading, setLoading] = useState<boolean>(false)
  const [success, setSuccess] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)
  const { loggedIn } = useSelector((state) => state.user)

  const performEmailAddressVerification = async () => {
    setLoading(true)

    try {
      await dispatch(
        ActionCreators.verifyEmailAddress({ email: email || '', token })
      )
      setSuccess(true)
    } catch (e) {
      console.warn(e)
      setError(
        'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal.'
      )
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (token) {
      performEmailAddressVerification()
    } else {
      setError(
        'Der Link ist ungültig, bitte prüfen Sie den Link zum Bestätigen Ihrer E-Mail-Adresse.'
      )
    }
  }, [])

  return (
    <SafeAreaView style={tw('flex-1')}>
      <ScrollView>
        <HGView>
          <View style={tw('px-3')}>
            <View style={tw('mt-24 mb-8 self-center')}>
              <HansGretelLogo />
            </View>

            <HGHeading>E-Mail-Adresse bestätigen</HGHeading>

            {loading && <HGText style={tw('mb-6')}>Bitte einen Moment…</HGText>}

            {!loading && (
              <>
                {error && <HGText style={tw('mb-6')}>{error}</HGText>}

                {success && (
                  <HGText style={tw('mb-6')}>
                    Ihr E-Mail-Adresse wurde erfolgreich bestätigt
                  </HGText>
                )}

                <HGButton
                  title="Zur App gehen"
                  onPress={() =>
                    navigation.replace(loggedIn ? 'SignedIn' : 'SignedOut')
                  }
                />
              </>
            )}
          </View>
        </HGView>
      </ScrollView>
    </SafeAreaView>
  )
}

export default VerifyEmailAddressScreen
